import type {Data, DataValue} from '../types';

export const isData = (value: DataValue | undefined): value is Data =>
  value !== undefined &&
  value !== null &&
  !Array.isArray(value) &&
  typeof value === 'object';
